import JobTitle from '../models/job-title.model';

/**
 * Read a job title retrieved from the backend.
 * @param {Object} o
 * @return {JobTitle}
 */
function readJobTitle(o) {
  return new JobTitle(o.type, o.name);
}

export {
  readJobTitle
};



// WEBPACK FOOTER //
// ./src/app/common/serializers/job-title.serializer.js